module.exports = __webpack_public_path__ + "img/autospin_btn.bee6530a.png";